import * as types from './stockActionTypes';

const initialState = {
  stockList: [],
  stockData: null,
  isLoading: false,
  error: null,
  addStockData: null,
  updateStockData: null,
  deleteStockData: null,
  // Sayfalama alanları
  totalCount: 0,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 0,
  hasPreviousPage: false,
  hasNextPage: false,
};

export const stockReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_STOCK_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_STOCK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        stockList: action.payload?.StockList || [],
        totalCount: action.payload?.TotalCount || 0,
        pageNumber: action.payload?.PageNumber || 1,
        pageSize: action.payload?.PageSize || 10,
        totalPages: action.payload?.TotalPages || 0,
        hasPreviousPage: action.payload?.HasPreviousPage || false,
        hasNextPage: action.payload?.HasNextPage || false,
        error: null
      };
    case types.GET_STOCK_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.ADD_STOCK_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_STOCK_SUCCESS:
      return { ...state, isLoading: false, addStockData: action.payload, error: null };
    case types.ADD_STOCK_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.UPDATE_STOCK_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_STOCK_SUCCESS:
      return { ...state, isLoading: false, updateStockData: action.payload, error: null };
    case types.UPDATE_STOCK_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.DELETE_STOCK_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_STOCK_SUCCESS:
      return { ...state, isLoading: false, deleteStockData: action.payload, error: null };
    case types.DELETE_STOCK_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
}; 